<template>
  <div class="container py-5">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6 mx-auto">
            <!-- form card login -->
            <div class="card rounded-0">
              <div class="card-header">
                <h4 class="mb-0">{{ $t('resetPwd.resetPassword') }}</h4>
              </div>
              <div class="card-body">
                <p class="text-left">
                  {{ $t('resetPwd.infoResetPassword') }}
                </p>

                <form
                  class="form text-left"
                  role="form"
                  autocomplete="off"
                  id="formLogin"
                  novalidate
                  @submit.prevent="onReset"
                >
                  <div class="form-group">
                    <label for="uname1">{{ $t('resetPwd.userEmail') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-bind:class="{ 'is-invalid': emailIsMissing }"
                      v-model="email"
                      name="uname1"
                      id="uname1"
                      required
                    />
                    <div class="invalid-feedback">{{ invalidEmail }}</div>
                  </div>

                  <button
                    type="submit"
                    class="btn btn-primary float-right"
                    id="btnLogin"
                  >
                    {{ $t('resetPwd.resetPwd') }}
                  </button>
                </form>
              </div>
              <!--/card-block-->
            </div>
            <!-- /form card login -->
          </div>
        </div>
        <!--/row-->
      </div>
      <!--/col-->
    </div>
    <!--/row-->
  </div>
  <!--/container-->
</template>

<script>
export default {
  data() {
    return {
      email: '',
      emailIsMissing: false,
      invalidEmail: this.$t('warnings.invalidEmail'),
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  props: {
    mode: {
      default: null,
    },
  },

  computed: {},

  methods: {
    validEmail: function () {
      return this.email == '' ? '' : this.reg.test(this.email) ? true : false;
    },

    onReset: function () {
      console.log('reset password was submitted');

      if (!this.validEmail(this.email)) {
        this.emailIsMissing = true;
        return;
      }
      this.emailIsMissing = false;

      let email = this.email;
      console.log('Try to reset password with email:' + email);

      this.$store
        .dispatch('reset', email)
        .then((response) => {
          console.debug(response.data);
          if (response.data.error) {
            this.emailIsMissing = true;
            this.invalidEmail = this.$t('warnings.emailNotFound');
            console.log('Password reset failed');
          } else {
            console.log(
              'Reset password was successfull. Click on email is the next step'
            );
            this.$router.push('/resetlink');
          }

          return;
        })
        .catch((err) => {
          console.log('Register err:' + err);
        });
    },
  },
};
</script>
